// Entry point for the build script in package.json

import Rails from "@rails/ujs";
import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
import "trix";
import "@rails/actiontext";
import "core-js/stable";
// Bootstrap is already imported by Niiwin, so leave this line commented out.
// import "bootstrap";
import "@fortawesome/fontawesome-free/js/all.js";
import "tom-select/dist/js/tom-select.complete.js";

Rails.start();
ActiveStorage.start();

// eslint-disable-next-line import/first
import "./channels";
// eslint-disable-next-line import/first
import "./controllers";

// Add specific icons we use from FontAwesome 6. All other icons will use FA5 as provided by Niiwin
import { faMapLocationDot } from "@fortawesome/free-solid-svg-icons";
FontAwesome.library.add(faMapLocationDot);
